import React from 'react';
import { useMatches } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectLastVisitedURL } from '@/features/query-builder/queryBuilderSlice';
import { EXPLORER } from '@/util/enums/views.constants';
import { TrevorIcon } from '@trevor/ui-components';
import { intersection } from 'ramda';
import { useDataPresentationParam } from '@/hooks';
import { NavigationItem } from './NavigationItem';

const QUERY_BUILDER_ROUTE_IDS = ['0-1-0-0', '0-1-0-1', '0-1-0-2'];

export const QueryBuilderNavigationItem = () => {
  const activeRoutesIds = useMatches().map((r) => r.id);
  const isActive =
    intersection(activeRoutesIds, QUERY_BUILDER_ROUTE_IDS).length > 0;
  const url = useNavigationUrl(isActive);

  return (
    <NavigationItem
      tab={EXPLORER}
      url={url}
      tooltipText="Query builder"
      active={isActive}
    >
      <TrevorIcon name="rocket" size="md" />
    </NavigationItem>
  );
};

const useNavigationUrl = (isActive: boolean) => {
  const presentation = useDataPresentationParam();
  const lastVisitedURL = useSelector(selectLastVisitedURL);
  const shouldNavigateToEditQueryView =
    isActive && presentation && lastVisitedURL?.endsWith(presentation);

  let editViewURL = '';
  if (lastVisitedURL && presentation) {
    editViewURL = lastVisitedURL?.substring(
      0,
      lastVisitedURL.length - (presentation.length + 1),
    );
  }

  return shouldNavigateToEditQueryView ? editViewURL : lastVisitedURL;
};
